import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const SpotlightCard = ({ title, description, image, link }) => {
  return (
    <motion.div 
      className="relative overflow-hidden rounded-[20px] group cursor-pointer w-full sm:w-[340px] md:w-[380px] lg:w-[420px]"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.2 }}
      onClick={() => window.open(link, '_blank')}
    >
      {/* Background Image */}
      <div className="relative w-full h-[268px]">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <div className="transform transition-transform duration-300 group-hover:-translate-y-4">
          <h3 className="text-[24px] lg:text-[26px] font-bold text-white mb-2 font-lexend">
            {title}
          </h3>
          <p className="text-[16px] lg:text-[18px] text-white/80 font-light font-lexend">
            {description}
          </p>
        </div>
        
        {/* Learn More */}
        <div className="flex items-center justify-end mt-4 transform translate-y-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="text-white text-[16px] lg:text-[18px] font-lexend">Learn more</span>
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="ml-2"
          >
            <path 
              d="M14 5L21 12M21 12L14 19M21 12H3" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </motion.div>
  );
};

const IndustrySpotlightsSection = ({ spotlights }) => {
  const { isDarkMode } = useTheme();

  return (
    <section className={`py-24 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          className={`text-[32px] sm:text-[36px] font-medium text-center mb-16 ${
            isDarkMode ? 'text-white' : 'text-black'
          } font-lexend`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Industry Spotlights
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 lg:gap-16 place-items-center">
          {spotlights.map((spotlight, index) => (
            <SpotlightCard key={index} {...spotlight} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustrySpotlightsSection; 